module.exports = __webpack_public_path__ + "files/64a041966a337caa701fa80123eb1210.svg";